import { Component, Input, OnInit, ViewChild } from '@angular/core';
//import { AppConfigService } from '../../../core/app.config.service';
import { GameMessageType, PrizeDetail, AddressCombined, AddressDetail } from '../../../../shared/constants/divisional.interface';
import { GameService } from '../../../../shared/services/game/game.service';
import { PRIZETYPES, USSTATES } from '../../../../shared/constants/constants';
import { Observable, Subject, of } from 'rxjs';
import { map, debounceTime, switchMap, catchError } from 'rxjs/operators';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-prize-redeem',
    templateUrl: './prize-redeem.component.html'
})
export class PrizeRedeemComponent implements OnInit {

    @Input() programName: string = null;
    @Input() gameId: string;
    @Input() tokenLabelSingular: string = '';
    @Input() tokenLabelPlural: string = '';
    public prize: PrizeDetail = null;
    addressDetails: Array<AddressDetail> = [];
    prizetypes = PRIZETYPES;
    invalidZipcode: boolean = false;
    inValidZipCodeValue: string = "";
    userInfo = null;
    sm = '575px';
    md = '768px';
    imagePath: string;
    private currentEnvironment: string;
    userData: any = {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: 'AL',
        zipcode: ''
    }
    tempData: any = {
        firstName: '',
        lastName: '',
    }
    selectedAddress: any = {
        name: 'address',
        value: ''
    }
    isLoading: boolean = false;
    searchSubject = new Subject();
    searchResult$: Observable<any>;
    addressFormErrorMsg: string = '';
    selectedIndex: number = null;
    primaryemail: string = '';
    phoneNumber: string = '';
    prizeRedeemButton: any;

    public bsModalRef: BsModalRef;
    closePRModal: boolean = false;
    gameModalMessage: any;

    @ViewChild('prizeRedeemModal') public prizeRedeemModal: ModalDirective;
    @ViewChild('addressListModal') public addressListModal: ModalDirective;
    @ViewChild('addressFormModal') public addressFormModal: ModalDirective;
    @ViewChild('redeemConfirmSuccessModal') public redeemConfirmSuccessModal: ModalDirective;
    @ViewChild('redeemErrorModal') public redeemErrorModal: ModalDirective;


    @ViewChild('addressForm', { static: true }) addressForm: NgForm;
    @ViewChild('addressDetailsForm') addressDetailsForm: NgForm;

    states: Array<{ name: string, value: string }> = USSTATES;

    constructor(
        private gameService: GameService,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.currentEnvironment = this.gameService.getEnvironment();
        this.imagePath = environment[this.currentEnvironment].imagePath;
        this.gameModalMessage = this.gameService.gameModalMessageObservable.subscribe(message => {
            // console.warn(message);
            if (message.mode == GameMessageType.PRIZEREDEEM) {

                this.prize = message.prizeDetail;
                this.gameId = message['gameId'] || '';
                this.userInfo = message.userInfo;
                this.prizeRedeemModal.show();
                this.prizeRedeemButton = message.elementEvent?.target;
            }

        });

        this.searchResult$ = this.searchSubject.pipe(
            debounceTime(1000),
            switchMap((searchText: string) => {
                return this.gameService.validateZipCode(searchText, this.userInfo).pipe(
                    catchError(error => {
                        this.inValidZipCodeValue = searchText;
                        this.invalidZipcode = true;
                        return of({ errorMessage: '' });
                    })
                );
            }),
            map((res: any) => {
                return { ...res }
            })
        );

        this.searchResult$.subscribe(
            data => {
                // console.warn('subscribe', data);
                if (data.hasOwnProperty('errorMessage')) {
                    this.setAddressFormErrored(data.errorMessage);
                } else {
                    this.setAddressFormErrored('');
                    this.userData.city = data.city;
                    this.userData.state = data.state;
                    this.validateStateAfterResponse(data.state);
                }
            });

    }

    validateStateAfterResponse(state: string) {
        if (state && state.length) {
            if ((this.states.filter(item => item.value === state)).length === 0) {
                this.addressForm.form.controls["state"].setValue('');
            }
        }
    }

    handleModalTrap(elementId: string) {
        this.gameService.trapFocus(`#${elementId}`);
    }

    removeModalTrap(elementId: string) {
        if (elementId === 'addressFormModal') {//reset address form on hiding the modal
            this.invalidZipcode = false;
            this.addressForm.resetForm({
                firstname: this.tempData.firstName,
                lastname: this.tempData.lastName,
                state: 'AL'
            });
            this.addressFormErrorMsg = '';
        }
        document.querySelector(`#${elementId}`).removeEventListener("keydown", this.gameService.trapFocus, false);

        // work around for GC-1834
        let element = document.querySelector('.modal-open');
        if (element) {
            element.classList.remove('modal-open');
        }
    }

    closePrizeRedeemModal() {
        this.isLoading = false;
        this.prizeRedeemModal.hide();
        if(this.prizeRedeemButton) {
            this.prizeRedeemButton.focus();
        }
    }

    confirmRedeem() {
        if (this.gameService.isAuthenticated(this.userInfo)) {
            if (this.prize.hasOwnProperty('digitalPrize') && !this.prize.digitalPrize) {
                this.confirmAddressForRedeem();
            } else {

                this.isLoading = true;
                if (this.prize.type == PRIZETYPES.SWEEPSTAKES || this.prize.type == PRIZETYPES.VENDOR) {
                    this.gameService.getCustomerType(this.userInfo).subscribe(
                        (response: AddressCombined) => {
                            this.userData.firstName = response?.firstName || '',
                            this.userData.lastName = response?.lastName || '',
                            this.phoneNumber = response?.phoneNumber || '';
                            this.callRedeemAPI();
                        },
                        err => {
                            this.isLoading = false;
                            // console.warn('error', err);
                        });
                } else {
                    this.callRedeemAPI();
                }

            }
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }
    }

    confirmAddressForRedeem(onSubmitSuccess: boolean = false) {
        if (this.gameService.isAuthenticated(this.userInfo)) {
            this.isLoading = true;
            this.gameService.getCustomerType(this.userInfo).subscribe(
                (response: AddressCombined) => {
                    this.isLoading = false;
                    this.addressDetails = response?.addresses || [];
                    this.primaryemail = response?.primaryemail || '';
                    this.phoneNumber = response?.phoneNumber || '';
                    this.userData.firstName = response?.firstName || '';
                    this.userData.lastName = response?.lastName || '';
                    this.tempData.firstName = this.userData.firstName.slice(0);
                    this.tempData.lastName = this.userData.lastName.slice(0);
                    if (this.addressDetails.length > 0) {
                        this.selectAddress(0);
                    }
                },
                err => {
                    this.isLoading = false;
                    // console.warn('error', err);
                },
                () => {
                    this.isLoading = false;
                    if (!onSubmitSuccess) {
                        this.prizeRedeemModal.hide();
                    } else { // On Success
                        this.addressFormModal.hide();
                    }
                    if (this.addressDetails.length === 0) {
                        this.showAddNewAddress();
                    } else {
                        this.addressListModal.show();
                    }

                });
        }
    }

    callRedeemAPI() {
        if (this.gameService.isAuthenticated(this.userInfo) && this.prize) {
            this.prizeRedeemModal.hide();
            this.addressListModal.hide();
            
            let redemptionRequest = {
                prizeId: this.prize.prizeId,
                prizeType: this.prize.type,
                programCode: this.prize.programCode,
                programName: this.programName,
                storeId: this.userInfo.storeId || this.userInfo.j4uStoreId,
                digitalPrize: true
            }

            if (this.prize.hasOwnProperty('digitalPrize') && !this.prize.digitalPrize) {
                let selectedAddress = this.addressDetails[this.selectedIndex];
                let userDetails = {
                    address1: selectedAddress.address,
                    address2: selectedAddress.address2,
                    city: selectedAddress.city,
                    emailAddress: this.primaryemail,
                    phoneNumber: this.phoneNumber,
                    state: selectedAddress.state,
                    zipCode: selectedAddress.zipCode,
                    firstName: selectedAddress.firstName,
                    lastName: selectedAddress.lastName,
                    digitalPrize: false
                }
                redemptionRequest = { ...redemptionRequest, ...userDetails };
            }
            
            if (this.prize.type == PRIZETYPES.VENDOR) {
                let userDetails = {
                    firstName: this.userData.firstName,
                    lastName: this.userData.lastName,
                    emailAddress: window['AB'] && window['AB'].userInfo && window['AB'].userInfo.email
                }
                redemptionRequest = { ...redemptionRequest, ...userDetails };
            }

            if (this.prize.type == PRIZETYPES.SWEEPSTAKES || this.prize.type == PRIZETYPES.VENDOR) {
                let userDetails = {
                    phoneNumber: this.phoneNumber
                }
                redemptionRequest = { ...redemptionRequest, ...userDetails };
            }

            this.isLoading = true;
            this.gameService.redeemToken(redemptionRequest, this.userInfo).subscribe(
                response => {
                    this.isLoading = false;
                    // console.warn('success redeem', response);
                    this.redeemConfirmSuccessModal.show();
                    if (window['AB'] && window['AB'].DATALAYER) {
                        window['AB'].DATALAYER.clipGamePoints(this.prize);
                    }
                },
                err => {
                    this.isLoading = false;
                    // console.warn('redeem error', err);
                    this.redeemErrorModal.show();
                }
            );
        }
    }

    setAddressFormErrored(err: string = '') {
        if (err && err != '') {

            this.addressForm && this.addressForm.form.controls["zipcode"].setErrors({ 'incorrect': true }) /* TODO: Not working */
        }
        this.addressFormErrorMsg = err;
    }

    // /** check for duplicates **/
    hasDuplicates() {
        return (this.addressDetails.filter(
            ad => (ad.city === this.userData.city &&
                ad.state === this.userData.state &&
                ad.address === this.userData.address &&
                parseInt(ad.zipCode + '', 10) === parseInt(this.userData.zipcode, 10))).length > 0 ? true : false);
    }

    closeAddressFormModal(addressFormModal: NgForm) {
        addressFormModal.resetForm({
            firstname: this.tempData.firstName,
            lastname: this.tempData.lastName,
            state: 'AL'
        });
        this.addressFormErrorMsg = '';
        this.userData.firstName = this.tempData.firstName; //re-assign
        this.userData.lastName = this.tempData.lastName; //re-assign
        this.addressFormModal.hide();
    }

    onSubmit() {
        this.addressFormErrorMsg = "";
        if (this.hasDuplicates()) {
            //set form errored
            // console.warn('has duplicates & set form errored');
            this.addressForm.form.setErrors({ 'invalid': true });
            this.addressFormErrorMsg = "Duplicate Address is not allowed";
            return false;
        }

        if (this.gameService.isAuthenticated(this.userInfo) && this.addressForm.valid) {
            const requiredData = {
                firstName: this.userData.firstName,
                lastName: this.userData.lastName,
                address: this.userData.address,
                address2: '',
                addressId: (this.addressDetails.length).toString(),
                addressType: {
                    name: "1"
                },
                city: this.userData.city,
                state: this.userData.state,
                zipCode: this.userData.zipcode
            };
            this.isLoading = true;
            this.addressDetails.push(requiredData);
            if (this.addressDetails.length) {
                this.addressFormModal.hide();
                this.addressListModal.show();
                this.selectAddress(this.addressDetails.length - 1);
                this.isLoading = false;
            }
        }
    }

    validateZipCode(ev: any) {
        this.invalidZipcode = false;
        const ele = ev.target as HTMLInputElement;
        if (ele.value.length > 5) {
            ele.value = ele.value.substring(0, 4);
            this.userData.zipcode = ele.value;
            ev.preventDefault();
            return false;
        }
        if (ele.value.length === 5 && /^[0-9]{5}$/.test(ele.value)) {
            this.setAddressFormErrored('');
            if(ele.value == this.inValidZipCodeValue) {
                this.invalidZipcode = true;
            }
            this.searchSubject.next(ele.value);
        }
    }

    selectAddress(index: number) {
        if (this.addressDetails.length > 0) {
            this.selectedAddress.value = this.addressDetails[index].addressId;
            this.selectedIndex = index;
        }
    }

    keyDownRadioGroup(event: any, idx: number) {
        const node = event.currentTarget;
        let next = null;
        switch (event.keyCode) {
            case 40:
            case 39:
                next = this.nextRadioButton(node, idx + 1);
                if (!next) next = this.firstRadioButton(node, 0);
                break;

            case 38:
            case 37:
                next = this.previousRadioButton(node, idx - 1);
                if (!next) next = this.lastRadioButton(node, this.addressDetails.length - 1);
                break;

            case 32:
                next = node;
                break;
        }

        if (next) {
            this.setRadioButton(next, "true");

            event.preventDefault();
            event.stopPropagation();
        }
    }

    nextRadioButton(node: any, idx: number) {
        let next = node.nextSibling;

        while (next) {
            if (next.nodeType === Node.ELEMENT_NODE) {
                if (next.getAttribute("role") === 'radio') {
                    this.selectAddress(idx);
                    return next;
                }
            }
            next = next.nextSibling;
        }

        return null;
    }

    previousRadioButton(node: any, idx: number) {
        let prev = node.previousSibling;

        while (prev) {
            if (prev.nodeType === Node.ELEMENT_NODE) {
                if (prev.getAttribute("role") === 'radio') {
                    this.selectAddress(idx);
                    return prev;
                }
            }
            prev = prev.previousSibling;
        }

        return null;
    }

    firstRadioButton(node: any, idx: number) {
        let first = node.parentNode.firstChild;

        while (first) {
            if (first.nodeType === Node.ELEMENT_NODE) {
                if (first.getAttribute("role") === 'radio') {
                    this.selectAddress(idx);
                    return first;
                }
            }
            first = first.nextSibling;
        }

        return null;
    }

    lastRadioButton(node: any, idx: number) {
        let last = node.parentNode.lastChild;

        while (last) {
            if (last.nodeType === Node.ELEMENT_NODE) {
                if (last.getAttribute("role") === 'radio') {
                    this.selectAddress(idx);
                    return last;
                }
            }
            last = last.previousSibling;
        }

        return last;
    }

    setRadioButton(node: any, state: string = "false") {
        if (state == 'true') {
            node && node.focus()
        }
    }

    showAddNewAddress() {
        if (this.addressDetails.length === 13) return;
        this.addressListModal.hide();
        this.addressFormModal.show();
    }

    backToAddressList(addressForm: NgForm) {
        addressForm.resetForm({
            firstname: this.tempData.firstName,
            lastname: this.tempData.lastName,
            state: 'AL'
        });
        this.addressFormErrorMsg = '';
        this.addressFormModal.hide();
        this.addressListModal.show();
    }

    closeAndRefresh() {
        this.redeemConfirmSuccessModal.hide();
        // trigger the screen to refresh
        this.gameService.prizeRedeemed.next({singleCard: true, selectedGame: this.gameId});
    }

    retryRedeem() {
        this.redeemErrorModal.hide();
        this.callRedeemAPI();
    }

    public getImageUrl(prize: PrizeDetail, viewport: string): string {
        let id = prize.prizeId;
        if (prize.type == PRIZETYPES.B4U_OFFER && prize.imageId) {
            id = prize.imageId;
        }
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }

    ngOnDestroy() {
        this.gameModalMessage && this.gameModalMessage.unsubscribe();
    }
}
